import { useMemo, useState } from 'react';
import {
  useNavigate,
  useParams,
  useLocation
} from 'react-router-dom';

import { Header } from '@/presentation/components';
import { AppDrawer } from '@/presentation/components/layout/AppDrawer/AppDrawer';
import { BottomAppBar } from '@/presentation/components/layout/BottomAppBar/BottomAppBar';
import { useAuthContext } from '@/presentation/context';
import { routes } from '@/presentation/router';

import { DiagnosticosSection } from './components/DiagnosticosSection';
import { SolucionesSection } from './components/SolucionesSection';
import { ComnetariosSection } from './components/ComentariosSection';
import { CreateDialog } from './components/CreateActionDialog';
import { Form } from '@/presentation/components/Forms/Form/Form';
import { useSimple } from '@/presentation/hooks/useSimple';
import { useIncidente } from '@/presentation/hooks/useIncidente';
import { DeleteActionDialog } from './components/DeleteActionDialog';

export default function ActionPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const { estado } =
    (location.state ?? {}) as { estado?: number };



  const {
    data: usuarios,
    reload: loadUsuarios,
  } = useSimple('usuarios');
  const [tipoResponsable, setTipoResponsable] = useState('');
  const {
    data: empresas,
    reload: loadEmpresas,
  } = useSimple('luc_empresas');

  const { user, logout } =
    useAuthContext();

  const [isDrawerOpen, setIsDrawerOpen] =
    useState(false);
  const optionsUsuarios = useMemo(
    () =>
      usuarios.map((usuario) => ({
        value: usuario.id,
        label: `${usuario.nombre} ${usuario.apellido}`,
      })),
    [usuarios]
  );
  const optionsEmpresas = useMemo(
    () =>
      empresas.map((empresa) => ({
        value: empresa.id,
        label: empresa.nombre,
      })),
    [empresas]
  );

  const [Logistica, setLogistica] = useState(false)
  const [EnEspera, setEnEspera] = useState(false)
  const [AsignarOpen, setAsignarOpen] = useState(false)
  const [finalizarOpen, setFinalizarOpen] = useState(false)
  const [atrasOpen, setAtrasOpen] = useState(false)
  const [nombreEstado, setNombreEstado] = useState('')

  const incidenteId = id ?? '0';

  const handleLogout = async () => {
    await logout();

    setIsDrawerOpen(false);

    navigate(routes.login, {
      replace: true,
    });
  };

  const { changeEstado: Asignar } = useIncidente();
  const { changeEstado: finalizar } = useIncidente();
  const handleAsignar = async (
    values: Record<string, unknown>
  ) => {
    let estado = 6
    if (Logistica) {
      estado = 5
    }
    const tipoResponsableSeleccionado = Number(
      values.tipo_responsable ?? tipoResponsable
    );

    if (!tipoResponsableSeleccionado) {
      throw new Error('Debe seleccionar un tipo de responsable');
    }

    const incidente = {
      estado: estado,
      responsable: Number(values.nombre),
      tipo_responsable: tipoResponsableSeleccionado,
      id_visita: 0
    };
    
    await Asignar(String(id), incidente);

    navigate(`/incidente/${id}`);
  };

  const handleFinalizar = async (
  ) => {
    let nuevoEstado = Number(estado) + 1
    if (estado == 5) {
      nuevoEstado = 8
    }
    if (estado == 2 && !EnEspera) {
      nuevoEstado = 4
    }
    const incidente = {
      estado: nuevoEstado,
      responsable: 0,
      tipo_responsable: 0,
      id_visita :0
    };
    await finalizar(String(id), incidente);

    navigate(`/incidente/${id}`);
  };

  const handleBack = async () => {
    let nuevoEstado = Number(estado) - 1
    if (estado == 6) {
      nuevoEstado = 1
    }
    if (estado == 4) {
      nuevoEstado = 2
    }
    const incidente = {
      estado: nuevoEstado,
      responsable: 0,
      tipo_responsable: 0,
      id_visita :0
    };
    await finalizar(String(id), incidente);
    navigate(`/incidente/${id}`);
  };


  const handleOpenAsignar = async () => {
    setNombreEstado('Asignar')
    if (usuarios.length === 0) {
      await loadUsuarios();
      
    }
    
    if (empresas.length === 0) {
      await loadEmpresas();
    }

    setAsignarOpen(true);
  };
  const handleOpenLogistica = async () => {
    setNombreEstado('Recepcionar')
    if (usuarios.length === 0) {
      await loadUsuarios();
    }
    if (empresas.length === 0) {
      await loadEmpresas();
    }
    setLogistica(true)

    setAsignarOpen(true);
  };

  return (
    <div>
      <Header
        title="Acciones en Incidente"
        onMenuClick={() =>
          setIsDrawerOpen(true)
        }
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={() =>
          setIsDrawerOpen(false)
        }
        onLogout={handleLogout}
      />
      <main style={{ padding: '24px' }}>
        <DiagnosticosSection
          incidenteId={incidenteId}
          estadoId={estado??0}
        />

        <SolucionesSection
          incidenteId={incidenteId}
        />
        <ComnetariosSection
          incidenteId={incidenteId}
        />

      </main>




      <BottomAppBar
        items={[
          ...(estado == 1
            ? [
              {
                label: 'Asignar',
                onClick: handleOpenAsignar,
                icon: undefined,
              }]
            : []),
          ...(estado == 1
            ? [
              {
                label: 'A Logística',
                onClick: () => { setFinalizarOpen(true), setNombreEstado('A Logística') },
                icon: undefined,
              }]
            : []),
          ...(estado == 2 || estado == 3
            ? [
              {
                label: 'Remitir',
                onClick: () => {
                  setEnEspera(false);
                  setFinalizarOpen(true);
                  setNombreEstado('Remitir')
                },
                icon: undefined,
              }]
            : []),
            ...(estado == 2
            ? [
              {
                label: 'En Espera de Repuesto',
                onClick: () => {
                  setEnEspera(true);
                  setFinalizarOpen(true);
                  setNombreEstado('Poner en Espera')
                },
                icon: undefined,
              }]
            : []),
          ...(estado == 4
            ? [
              {
                label: 'Recepcionar',
                onClick: handleOpenLogistica,
                icon: undefined,
              }]
            : []),
          ...(estado == 6
            ? [
              {
                label: 'Poner en Curso',
                onClick: () => { setFinalizarOpen(true), setNombreEstado('Poner en Curso') },
                icon: undefined,
              }]
            : []),
          ...(estado == 7 || estado == 5
            ? [
              {
                label: 'Cerrar',
                onClick: () => { setFinalizarOpen(true), setNombreEstado('Cerrar') },
                icon: undefined,
              }]
            : []),
          ...(estado != 1 && estado != 8
            ? [
              {
                label: 'Volver al Estado Anterior',
                onClick: () => { setAtrasOpen(true)},
                icon: undefined,
              }]
            : []),

        ]}
      />

      <CreateDialog
        open={AsignarOpen}
        title="Asignar Equipo"
        onClose={() => setAsignarOpen(false)}
      >
        <Form
          fields={[
            {
              name: 'tipo_responsable',
              type: 'select',
              label: 'Tipo de Responsable',
              options: [
                {
                  value: 1,
                  label: 'Identimax',
                },
                {
                  value: 2,
                  label: 'Empresa Externa',
                },
              ],
            },

            ...(tipoResponsable === '1'
              ? [
                {
                  name: 'nombre',
                  type: 'select' as const,
                  label: 'Responsable',
                  options: optionsUsuarios,
                },
              ]
              : []),

            ...(tipoResponsable === '2'
              ? [
                {
                  name: 'nombre',
                  type: 'select' as const,
                  label: 'Empresa Responsable',
                  options: optionsEmpresas,
                },
              ]
              : []),
          ]}
          submitLabel="Aceptar"
          onFieldChange={(name, value) => {
            if (name === 'tipo_responsable') {
              setTipoResponsable(String(value));
            }
          }}
          onSubmit={handleAsignar}
        />
      </CreateDialog>
      <DeleteActionDialog
        open={finalizarOpen}
        title={`${nombreEstado} el incidente`}
        message={`¿Seguro que quiere ${nombreEstado.toLowerCase()} el incidente?`}
        onClose={() => {
          setFinalizarOpen(false);
          setEnEspera(false);
        }}
        onConfirm={handleFinalizar}
      />
      <DeleteActionDialog
        open={atrasOpen}
        title={`Volver al estado anterior`}
        message={`¿Seguro que quiere volver al estado anterior?`}
        onClose={() => setAtrasOpen(false)}
        onConfirm={handleBack}
      />
    </div>
  );
}
